var SCM = SCM || {};

SCM.SeamlessAccess = (function ($) {
	var persistenceService;
	var discoveryService;
	var persistenceContext;
	var isInitialized = false;

	return {
		init: _init,
		saveShibbolethID: saveShibbolethID,
		latestShibboleth: latestShibboleth,
		removeShibbolethID: removeShibbolethID,
		initialized: initialized
	};

	function _init() {
		SCM.Retry.policy()
			.handleResult(function (result) { return !result; })
			.waitAndRetry(5, 500)
			.execute(function () {
				return thissInitialized();
			})
			.then(function (result) {
				initializeSeamless();
			})
			.catch(function (reason) {
				console.error('SCM.SeamlessAccess - timed out waiting for thiss to be ready.');
			});
	}

	function thissInitialized() {
		return thiss && thiss.PersistenceService && thiss.DiscoveryService;
	}

	function initializeSeamless() {
		persistenceContext = 'seamlessaccess.org'; /* change this context value to persist entities in your own context (i.e. key). */
		persistenceService = new thiss.PersistenceService('https://service.seamlessaccess.org/ps/'); // prod url
		discoveryService = new thiss.DiscoveryService('https://md.seamlessaccess.org/entities/',
			'https://service.seamlessaccess.org/ps/', 'test');
		isInitialized = true;
	}

	function initialized() {
		return isInitialized;
	}

	//internal routine to sort entities by most recent
	function compareByMostRecentLastUse(a, b) {
		return b.last_use - a.last_use;
	}

	//This saves a shibboleth ID and calls back to function passed in
	//It looks up the entity information to persist in the seamless access entity storage
	function saveShibbolethID(shibbolethID, preferredTitle) {
		return waitForThiss()
			.then(function (result) {
				if (!isInitialized) {
					initializeSeamless();
				}

				return discoveryService.mdq(shibbolethID).then(function (entity) {
					if (!entity) {
						//Create entity if we can not discover it
						entity = createDefaultEntity(shibbolethID, preferredTitle);
					}
					return saveEntity(entity, preferredTitle);
				});
			});
	}

	function waitForThiss() {
		return SCM.Retry.policy()
			.handleResult(function (result) { return !result; })
			.waitAndRetry(5, 500)
			.execute(function () {
				return thissInitialized();
			})
			.catch(function (reason) {
				console.error('waitForThiss - timed out waiting for thiss to be ready.');
			});
    }

	function createDefaultEntity(shibbolethID, preferredTitle) {
		return {
			"entity_icon": "",
			"descr": preferredTitle,
			"title": preferredTitle,
			"name_tag": preferredTitle,
			"type": "idp",
			"auth": "other",
			"entity_id": shibbolethID,
			"entityID": shibbolethID,
			"hidden": "",
			"scope": "",
			"id": shibbolethID
		};
	}

	//This removes a shibboleth ID and calls back to function passed in
	//It looks up the entity information to persist in the seamless access entity storage and removes it
	function removeShibbolethID(shibbolethID) {
		return discoveryService.mdq(shibbolethID).then(function (entity) {
			if (!entity)
			{
				//Create entity if we can not discover it
				entity  = createDefaultEntity(shibbolethID, '');
			}
			return removeEntity(entity);
		});
	}

	//This call gets the latest shibboleth entities stored in seamless access storage, via a callback function.
	function latestShibboleth() {
		return waitForThiss()
			.then(function (result) {
				if (!isInitialized) {
					initializeSeamless();
				}

				return persistenceService.entities(persistenceContext)
					.then(function (res) {
						return res.data.sort(compareByMostRecentLastUse);
					});
			});
	}

	//Persist in the seamless access entity storage
	function saveEntity(entity, preferredTitle) {
		entity.title = preferredTitle;
		return persistenceService.update(persistenceContext, entity).then(latestShibboleth);
	}

	//Persist in the seamless access entity storage
	function removeEntity(entity, callback) {
		return persistenceService.remove(persistenceContext, entity.entity_id).then(latestShibboleth);
	}

})(jQuery);
